export class EventStore {
    constructor(events) {
        this._observers = [];
        this.set(events || []);
    }
    subscribe(observer) {
        this._observers.push(observer);
        this.set(this._events);
        return () => this.unsubscribe(observer);
    }
    unsubscribe(observer) {
        this._observers = this._observers.filter(ob => ob !== observer);
    }
    set(events) {
        this._events = [...events];
        this.length = this._events.length;
        this._observers.forEach(ob => {
            ob(this._events);
        });
    }
    add(event) {
        if (this.includes(event.eventData))
            return;
        this.set([...this._events, event]);
    }
    remove(id) {
        if (!this._events.find(ev => ev.eventData.id === id))
            return;
        this.set(this._events.filter(ev => ev.eventData.id !== id));
    }
    update(event) {
        this.set([
            ...this._events.filter(ev => ev.eventData.id !== event.eventData.id),
            event,
        ]);
    }
    get() {
        return this._events;
    }
    getEvent(id) {
        return this._events.find(({ eventData }) => eventData.id === id);
    }
    includes(event) {
        return !!this.getEvent(event.id);
    }
}
//# sourceMappingURL=eventStore.js.map